document.addEventListener('DOMContentLoaded', function () {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

  gsap.registerPlugin(ScrollTrigger);

  const section = document.querySelector('#borrStoryTimeline');
  if (!section) return;

  const track = section.querySelector('.borr-story-track');
  const panels = gsap.utils.toArray('#borrStoryTimeline .borr-story-panel');
  const progressBar = section.querySelector('.borr-story-progress span');

  if (!track || !panels.length) return;

  const scrollDistance = () => track.scrollWidth - window.innerWidth;

  const horizontalTween = gsap.to(track, {
    x: () => -scrollDistance(),
    ease: 'none',
    scrollTrigger: {
      trigger: section,
      start: 'top top',
      end: () => '+=' + scrollDistance(),
      pin: true,
      pinSpacing: true,
      scrub: 1,
      invalidateOnRefresh: true,
      anticipatePin: 1,
      onEnter: () => section.classList.add('is-active'),
      onEnterBack: () => section.classList.add('is-active'),
      onLeave: () => section.classList.remove('is-active'),
      onLeaveBack: () => section.classList.remove('is-active'),
      onUpdate: self => {
        if (progressBar) {
          progressBar.style.width = (self.progress * 100) + '%';
        }
      }
    }
  });

  panels.forEach(panel => {
    const textItems = panel.querySelectorAll('.borr-story-text span, .borr-story-text h2, .borr-story-text p, .borr-story-button, .borr-story-final span, .borr-story-final h2, .borr-story-final p');
    const image = panel.querySelector('.borr-story-image img');
    const imageWrap = panel.querySelector('.borr-story-image');
    const year = panel.querySelector('.borr-story-year');

    gsap.from(textItems, {
      y: 80,
      opacity: 0,
      filter: 'blur(10px)',
      stagger: .08,
      duration: .9,
      ease: 'power3.out',
      scrollTrigger: {
        trigger: panel,
        containerAnimation: horizontalTween,
        start: 'left 70%',
        toggleActions: 'play none none reverse'
      }
    });

    if (imageWrap) {
      gsap.from(imageWrap, {
        clipPath: 'inset(12% 12% 12% 12% round 28px)',
        scale: .94,
        rotate: -3,
        duration: 1,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: panel,
          containerAnimation: horizontalTween,
          start: 'left 75%',
          toggleActions: 'play none none reverse'
        }
      });
    }

    if (image) {
      gsap.to(image, {
        yPercent: -8,
        scale: 1.02,
        ease: 'none',
        scrollTrigger: {
          trigger: panel,
          containerAnimation: horizontalTween,
          start: 'left right',
          end: 'right left',
          scrub: true
        }
      });
    }

    if (year) {
      gsap.from(year, {
        x: 120,
        opacity: 0,
        ease: 'none',
        scrollTrigger: {
          trigger: panel,
          containerAnimation: horizontalTween,
          start: 'left right',
          end: 'center center',
          scrub: true
        }
      });
    }
  });

  window.addEventListener('load', function () {
    ScrollTrigger.refresh();
  });

  setTimeout(function () {
    ScrollTrigger.refresh();
  }, 700);
});